module.exports = __webpack_public_path__ + "static/img/indexPic2.7c2921b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic2.png
// module id = E6ru
// module chunks = 1